import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';
import heroImg from '../../images/tmp/tnc.jpg';
import PropTypes from 'prop-types';

import {
  SITE_TITLE,
} from '../../constants';

class PrivacyDisclaimer extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <Helmet>
          <title>{t('nav:privacyDisclaimer')} | { SITE_TITLE }</title>
        </Helmet>
        <article className="fe-privacy">
          <div className="container">
            <div className="row">
              <div className="col">
                <h1 className="fe-heading">{t('form:privacyDisclaimer')}</h1>

                <div className="fe-privacy-main-div">
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">I.</div>
                    <div className="fe-privacy-text title">General</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Welcome to our website. This website is operated by Ford Motor Company (“Ford”) and Sime Darby Motors’ (“Sime Darby Motors”) (together as “Website Owners” or “We” or “us”). If you continue to browse and use this website, you are agreeing to comply with and be bound by the following terms and conditions that govern the relationship between you and us in relation to this website.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">The term “Sime Darby Motors” refers to:-</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">(a) the co-owner of the website whose registered address Level 9, Menara Sime Darby, Oasis Corporate Park, Jalan PJU 1A/2, Ara Damansara, 47301 Petaling Jaya, Selangor; and/or</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">(b) any one (1) of our motor units located and carrying out the business of distribution, retail and/or after-sales service of motor vehicles in Malaysia as follows:-</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(bi) Auto Bavaria, a division of Sime Darby Auto Bavaria Sdn Bhd (formerly known as Sime Darby  Motor Division Sdn Bhd)</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(bii) Hyundai-Sime Darby Motors Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(biii) Land Rover (Malaysia) Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(biv) Sime Darby Auto Connexion Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(bv) Sime Darby Auto Hyundai Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(bvi) Sime Darby Auto Italia Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(bvii) Sime Darby Auto Performance Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(bviii) Sime Darby Rent A Car Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(bix) Sime Darby Auto Britannia Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-text">(bx) Sime Darby Auto Selection Sdn Bhd</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">The term “you” refers to the user or viewer of our website.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Ford and Sime Darby Motors reserve the right to amend the terms and conditions and the content of the website without any prior notification.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.</div>
                    <div className="fe-privacy-text title">Privacy Policy</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">This privacy policy; in accordance with the Malaysian Personal Data Protection Act 2010; sets out how Ford and Sime Darby Motors uses and protects any information that you give when you use this website.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Ford and Sime Darby Motors individually are committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website; you can be assured that it will only be used in accordance with this privacy policy.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Ford and Sime Darby Motors may change this policy from time to time by updating this page. You should periodically visit this page from time to time to ensure that you are happy with any changes. This policy is effective from 15 August 2016.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">This privacy policy applies to all information collected or submitted on this website.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.1</div>
                    <div className="fe-privacy-text title">What we collect</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-text">We may collect the following information:</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Name, company name and job title</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Contact information including address, phone number and email address</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Demographic information such as postcode, preferences and interests</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Personal/financial information such as EA forms, religion, date of birth, age*</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Other information relevant to motor vehicle purchase, customer surveys and/or others</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">*The personal information is required if you require us to assist you to apply for a hire-purchase loan to finance the purchase of any motor vehicle from us.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.2</div>
                    <div className="fe-privacy-text title">What we do with the information we gather</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-text">We require this information to understand your needs and provide you with better service, and in particular for the following reasons:</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Inspection and/or registration of motor vehicle ownership at the relevant governmental and/or regulatory authorities including Puspakom and/or Jabatan Pengangkutan Jalanraya.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Internal record keeping includes the updating of our after-sales service records of the motor vehicle. This relevant information will be used by Website Owners, our appointed after-sales service dealers, agents and/or sub-contractors to provide the relevant after-sales service and/or repair as well as to communicate with you on any matter relating to the provision of the service in general.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Improvement of our products and services.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Customization of our website.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Activation of motor vehicle warranty with the relevant motor importers/distributors and/or relevant motor/manufacturer overseas and the activation of motor vehicle extended warranty with the relevant insurance company (ies).</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Disclosure of your information to service providers, agents and/or contractors from time to time to help us to provide and market our products and services to you and you have the option to elect not to receive any direct marketing promotional information from us in the manner as referred to in Item No. II.3 below.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">For statistical analysis and includes our disclosure of your information to our customer service agencies for research and analysis purposes so that we can monitor and improve the services we provide; for administrative purposes and statistical analysis.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.3</div>
                    <div className="fe-privacy-text title">Protection of Personal Information</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">We are committed to ensuring that your information is secure. In order to prevent unauthorized access or disclosure we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information that we collect online.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law. We may use your personal information to send you direct marketing information about us and/or third parties which we think you may find interesting if you tell us that you wish this to happen.</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-text">You may choose to limit the collection and/or use of your information by the following manner:-</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">When you are asked to fill in the form contained in this website, you may indicate your choice/preference by ticking against the box(es) stated in the said form on whether you would like (or not) for your information to be used by us for direct marketing information to you.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">If you have earlier agreed for us to use your information to send direct marketing information to you and you do not wish to receive any more direct marketing information about us and/or third parties, you may:-</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point"></div>
                      <div className="fe-privacy-row no-gap">
                        <div className="fe-privacy-point">a.</div>
                        <div className="fe-privacy-text">put your request in writing by way of an e-mail sent to us with a header that says “Unsubscribe” or “Delete” to remove your personal information mailto:- <a href="mailto:ford.unsubscribe@simedarby.com">ford.unsubscribe@simedarby.com;</a></div>
                      </div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point"></div>
                      <div className="fe-privacy-row no-gap">
                        <div className="fe-privacy-point">b.</div>
                        <div className="fe-privacy-text">provide us with enough information to identify you (eg. your account number, username, registration details).</div>
                      </div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point"></div>
                      <div className="fe-privacy-row no-gap">
                        <div className="fe-privacy-point">c.</div>
                        <div className="fe-privacy-text">if your objection is not to direct marketing in general, but to direct marketing by a particular channel (e.g. SMS, email or telephone), please specify the channel you are objecting to.</div>
                      </div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.4</div>
                    <div className="fe-privacy-text title">Retention of information</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-text">In view that the ownership of a motor vehicle may remain with its owner and/or the use of a motor vehicle can be for any particular length of time, we will retain your information as well as the information of the motor vehicle registered to you for the following time duration:-</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Five (5) years from the date:-</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point"></div>
                      <div className="fe-privacy-row no-gap">
                        <div className="fe-privacy-point">&#9679;</div>
                        <div className="fe-privacy-text">of the motor vehicle is registered into your ownership; or</div>
                      </div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point"></div>
                      <div className="fe-privacy-row no-gap">
                        <div className="fe-privacy-point">&#9679;</div>
                        <div className="fe-privacy-text">when any other party inform us that he/she/they is/are the new owner of the motor vehicle</div>
                      </div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">Five (5) years (or such other longer time) from the :-</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point"></div>
                      <div className="fe-privacy-row no-gap">
                        <div className="fe-privacy-point">&#9679;</div>
                        <div className="fe-privacy-text">date the motor vehicle warranty is activated with the motor manufacturer overseas and/or the date the motor vehicle extended warranty is activated with the insurance company(ies); or</div>
                      </div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point"></div>
                      <div className="fe-privacy-row no-gap">
                        <div className="fe-privacy-point">&#9679;</div>
                        <div className="fe-privacy-text">last date the motor vehicle was sent to our after-sales service centre/workshop for service and/or repair works.</div>
                      </div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">&#9679;</div>
                      <div className="fe-privacy-text">One (1) year from the date you submit your information and/or details to us through submission via our website and/or our consent form(s) when you visit us and/or our appointed sales and/or after-sales dealer(s).</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.5</div>
                    <div className="fe-privacy-text title">How we use cookies</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Acookie is a small file which asks permission to be placed on your computer’s hard disk. Once you agree, the file is added and the cookie helps analyses web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preference.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">We use traffic log cookies to identify which pages are being used. This helps us to analyses data about web page traffic and improves our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.6</div>
                    <div className="fe-privacy-text title">Links to other websites</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Our website may contain links to enable you to visit our group of companies’ websites and other third parties’ websites of interest easily. However, once you have used these links to leave our site, you should note that we do not have any control over the nature, content and/or availability of those other websites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy statement. You should exercise caution and look at the privacy statement applicable to the website in question.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.7</div>
                    <div className="fe-privacy-text title">Access and Accuracy of your information</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">You have a right to:-</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">Request a copy of your personal information we hold about you (for which we may charge a small fee) for granting you access in your information. If you wish to exercise this right, you may:-</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">a.</div>
                      <div className="fe-privacy-text">put your request in writing;</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">b.</div>
                      <div className="fe-privacy-text">include proof of your identity and address (e.g. a copy of your driving license and a recent credit card bill); and</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">c.</div>
                      <div className="fe-privacy-text">specify the personal information you want access to, including any account or reference numbers where applicable.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">Correct any inaccuracies in your data free of charge. If you wish to exercise this right, you should:-</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">a.</div>
                      <div className="fe-privacy-text">put your request in writing;</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">b.</div>
                      <div className="fe-privacy-text">provide us with enough information to identify you (e.g. your account number, username, registration details); and</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">c.</div>
                      <div className="fe-privacy-text">specify the information that is incorrect and what it should be replaced with.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">II.8</div>
                    <div className="fe-privacy-text title">To Reach Out to us</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-text">We welcome your views and feedback about our data protection policy and your personal information furnished to us. If you would like to contact us with any queries or comments, you may reach out to our Customer Relations Department by:-</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">a.</div>
                      <div className="fe-privacy-text">calling telephone number: 1-300-383-181; or</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">b.</div>
                      <div className="fe-privacy-text">sending an email to <a href="mailto:customercare.sdac@simedarby.com">customercare.sdac@simedarby.com</a> or</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point"></div>
                    <div className="fe-privacy-row no-gap">
                      <div className="fe-privacy-point">c.</div>
                      <div className="fe-privacy-text">sending a letter to us at Sime Darby Auto ConneXion, Ford at Level 3, Block 2, Sime Darby Motors City, Pusat Automotif Sime Darby, No.6, Jalan PJU 1A/7, Ara Damansara, 47301 Petaling Jaya, Selangor.</div>
                    </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text title">Terms Of Use</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">The use of this website is subject to the following terms of use:</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">he content of the pages of this website is for your general information and use only. It is subject to change without notice. You are advised to visit our website from time to time to ensure that you are happy with any changes.</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude any liability for any such inaccuracies or errors to the fullest extent permitted by law.</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">Your use of any information or materials on this website is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through this website meet your specific requirements.</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">This website contains material which is owned by or licensed to us. This material includes, but is not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms andconditions.</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">All tradenames and trademarks reproduced in this website, which are not the property of, or licensed to us, are acknowledged on the website.</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">Unauthorized use of this website may give to a claim for damages and/or a criminal offence.</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">From time to time, this website may also include links to other websites including the Ford and Sime Darby group of companies. These links are provided for your convenience to provide further information. Other than the Ford and Sime Darby group of companies’ websites, we do not endorse other third parties’ websites. We have no responsibility for the content and/or security of the linked third parties’ website(s).</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">You may not create a link to this website from another website or document without Ford and Sime Darby Motors’ prior written consent.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">Your use of this website and any dispute arising out of such use of the website is subject to the laws of Malaysia.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text title">Website Disclaimer</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">The information contained in this website is for general information purposes only. The information provided by Ford and Sime Darby Motors and whilst we endeavour to keep the information up-to- date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services or related graphics contained in the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arise out of or in connection with the use of this website.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Whilst every effort is made to keep the website up and running smoothly, Ford and Sime Darby Motors takes no responsibility for and will not be liable for the website being temporarily unavailable due to technical issues beyond our control and/or the unauthorized access and improper use of your information beyond our reasonable control.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">We reserve the right to discontinue or change any of the models, prices, colours, materials, equipment or other specifications referred to on this site at any time without notice. Some of the equipment shown or referred to in this site may only be available as an option at extra cost. Always consult an Authorized Ford Dealer for the latest information about a Ford product, and its availability, before placing an order.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point title">III</div>
                    <div className="fe-privacy-text title">Copyright & Trademark Notice </div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">All copyrights in this website (includes text, graphics, logo, icons, video and sound recordings) is owned or licensed to Ford and Sime Darby Motors and shall be protected under the Malaysian Copyright Act 1987.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Any redistribution or reproduction of part or all of the contents in any form is prohibited other than the following:-</div>
                  </div>
                  <div className="fe-privacy-row no-gap">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">You may print or download to a local hard disk extracts for your personal and noncommercial use only.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-point">&#9679;</div>
                    <div className="fe-privacy-text">You may copy the content to individual third parties for their personal and non-commercial use, but only if you acknowledge this website as the source of the material.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Except with our prior express written permission, you may not adapt, reproduce, distribute, create any derivative works from any part of this website or commercially exploit the contents of this website. Nor may you transmit it or store it in any other website or other form of electronic retrieval system.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Adobe®, Acrobat® and Reader® are either registered tradenames or trademarks of Adobe Systems Incorporated in the United States and/or other countries – for further details, please see <a href="http://www.adobe.com." rel="noopener noreferrer" target="_blank">http://www.adobe.com</a>.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">Microsoft®, Word®, Excel®, PowerPoint®, Windows® and Silverlight™ are either registered tradenames or trademarks of Microsoft Corporation in the United States and/or other countries – for further details, please see <a href="http://www.microsoft.com." rel="noopener noreferrer" target="_blank">http://www.microsoft.com</a>.</div>
                  </div>
                  <div className="fe-privacy-row">
                    <div className="fe-privacy-text">WinZip® is a registered trademark of WinZip International LLC – for further details, please sees <a href="http://www.winzip.com." rel="noopener noreferrer" target="_blank">http://www.winzip.com</a>.</div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </article>
      </>
    );
  }
}

PrivacyDisclaimer.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PrivacyDisclaimer);
